import React, { useEffect, useState } from 'react';
import { Card, Table, Button, Space, message, Typography } from 'antd';
import { EditOutlined, FileTextOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { apiClient } from 'Utils/api';

const { Title } = Typography;

interface PageItem {
  id: string;
  slug: string;
  label: string;
}

const PagesListPage: React.FC = () => {
  const navigate = useNavigate();
  const [pages, setPages] = useState<PageItem[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchPages();
  }, []);

  const fetchPages = async () => {
    setLoading(true);
    try {
      const res = await apiClient.get('/api/admin/pages');
      setPages(res.data.pages || []);
    } catch (e: any) {
      message.error(e.response?.data?.message || 'Fehler beim Laden der Seiten');
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: 'Seite',
      dataIndex: 'label',
      key: 'label',
      render: (label: string) => (
        <Space>
          <FileTextOutlined style={{ color: '#b08d2c' }} />
          <strong>{label}</strong>
        </Space>
      ),
    },
    { title: 'Slug', dataIndex: 'slug', key: 'slug' },
    {
      title: 'Aktionen',
      key: 'actions',
      width: 120,
      render: (_: any, record: PageItem) => (
        <Button
          type="primary"
          icon={<EditOutlined />}
          onClick={() => navigate(`/pages/${record.slug}`)}
          data-testid={`edit-page-${record.slug}`}
        >
          Bearbeiten
        </Button>
      ),
    },
  ];

  return (
    <div>
      <Title level={3}>Seitenverwaltung</Title>
      <Card>
        <Table
          rowKey="id"
          dataSource={pages}
          columns={columns}
          loading={loading}
          pagination={false}
        />
      </Card>
    </div>
  );
};

export default PagesListPage;
